var _dec, _class;
import { classNames } from '@ember-decorators/component';
import { TextField } from '@ember/legacy-built-in-components';
import ValidatedViewSupport from '@dashboard/shared-ui/mixins/validated-view-support'; // eslint-disable-line ember/no-mixins
let ValidatedInput = (_dec = classNames('input', 'l-fill'), _dec(_class = class ValidatedInput extends TextField.extend(ValidatedViewSupport) {}) || _class);
export { ValidatedInput as default };